import Box from "@mui/material/Box";
import React from "react";

export default function ErrorSection({ children }) {
  return (
    <React.Fragment>
      <Box
        sx={{
          backgroundColor: "error.lightBg",
          color: "error.main",
          p: "20px 16px",
          mb: "20px"
        }}
        id="error-section"
      >
        {children}
      </Box>
    </React.Fragment>
  );
}
